/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * Default module implementation.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module.DropDownCascade
	 * @class DropDownCascade
	 * @extends Tc.Module
	 */
	Tc.Module.DropDownCascade = Tc.Module.extend({
		
		NO_CLIENT_VALIDATION: "{&quot;required&quot;:false,&quot;requiredMessage&quot;:&quot;&quot;,&quot;hasLengthValidation&quot;:false,&quot;minLength&quot;:0,&quot;maxLength&quot;:10000,&quot;lengthRegex&quot;:null,&quot;lengthMessage&quot;:&quot;&quot;,&quot;constraintRegex&quot;:null,&quot;constraintType&quot;:null,&quot;constraintMessage&quot;:&quot;&quot;,&quot;constraintData&quot;:{},&quot;foreignValidationModels&quot;:{},&quot;hasConstraint&quot;:false}",
		
		/**
		 * Initializes the Default module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function($ctx, sandbox, modId) {
			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
            var mod = this;

            mod.changeDropDownHtml();
			callback();
		},
		
		changeDropDownHtml : function() {
			var mod = this;
			$.getJSON(mod.$ctx.data('json-url'), function(json) {
				var selects = mod.$ctx.find('select');
				var selectText = mod.$ctx.data('select-text');
			    var fillSelect = function ($this, parentJson) {
			        var i;
			        
			        $this.empty();
			        $this.append('<option value="">'+ selectText +'</option>');
			        for (i=0; i<parentJson.length; i++) {
			            var option = $('<option value="' + parentJson[i].name + '">' + parentJson[i].name + '</option>');
			            
			            option.data('json', parentJson[i].items);
			            $this.append(option);
			            $this.parent().show();
			        }
			        $this.resetSS();
			    };

			selects.parent().hide();
			selects.each(function() {
				var option = $(this).children('option:first');
				if(option.attr("value") == -1) {
					option.attr("value", "");
				}
			});
			selects.on('change', function () {
				var $this = $(this),
		        nextSelect = selects.eq(selects.index($this) + 1),
		        nextJson = $this.find("option:selected").data('json');

				if (nextSelect.length) {
					var selectBox = nextSelect.closest('.modSelectbox');
					if (nextJson && nextJson.length) {
						fillSelect(nextSelect, nextJson);
						
						if (selectBox && selectBox.data('clientvalidation-origin')) {
							selectBox.data('clientvalidation', selectBox.data('clientvalidation-origin'));
							selectBox.removeData('clientvalidation-origin');
						}
					} else {
						if(selectBox && !selectBox.data('clientvalidation-origin')){
							selectBox.data('clientvalidation-origin', selectBox.data('clientvalidation'));
							selectBox.data('clientvalidation', mod.NO_CLIENT_VALIDATION);
						}
						
						nextSelect.parent().hide();
						nextSelect.empty().trigger('change');
					}
				}
			});
			fillSelect(selects.first(), json);
			selects.resetSS();
			
			});
			
		}
		
	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/desktop/js/modules/Tc.Module.DropDownCascade.js
// module id = 273
// module chunks = 0